export const offers = [
  {
    type: 'taxi',
    offers: [
      {
        id: 'b4c3e4e6-9053-42ce-b747-e281314baa31',
        title: 'за три сотки хоть на край света',
        price: 300
      },
      {
        id: 'b4c3e4e6-9053-42ce-b747-e281314baa32',
        title: 'лакшери',
        price: 1150
      },
      {
        id: 'b4c3e4e6-9053-42ce-b747-e281314baa33',
        title: 'сам дойдешь',
        price: 10
      },
      {
        id: 'b4c3e4e6-9053-42ce-b747-e281314baa34',
        title: 'вообще улет',
        price: 1240
      },
      {
        id: 'b4c3e4e6-9053-42ce-b747-e281314baa35',
        title: 'местные',
        price: 140
      },
    ]
  },

  {
    type: 'bus',
    offers: [
      {
        id: 'b4c3e4e6-9053-42ce-b747-e281314baa40',
        title: 'наш',
        price: 1200
      },
      {
        id: 'b4c3e4e6-9053-42ce-b747-e281314ba331',
        title: 'зарубежный',
        price: 350
      },
      {
        id: 'b4c3e4e6-9053-42ce-b447-e281314baa31',
        title: 'отечественный',
        price: 100
      },
      {
        id: 'b4c3e4e6-9043-42ce-b747-e281314baa31',
        title: 'чей-то',
        price: 1240
      },
    ]
  },

  {
    type: 'restaurant',
    offers: [
      {
        id: 'b4c3e4e6-9353-42ce-b747-e281314baa31',
        title: 'мацони',
        price: 1120
      },
      {
        id: 'b4c3e4e6-9053-42ce3b747-e281314baa31',
        title: 'галя гуляй',
        price: 500
      },
      {
        id: 'b4c3e4e1-9053-42ce-b747-e281314baa31',
        title: 'грей гус',
        price: 1300
      },
    ]
  },
  {
    type: 'sightseeing',
    offers: []
  },
  {
    type: 'train',
    offers: []
  },
  {
    type: 'ship',
    offers: []
  },
  {
    type: 'drive',
    offers: []
  },
  {
    type: 'check-in',
    offers: []
  }
];
